// extracted by mini-css-extract-plugin
export default {"display":"zP-LV","device":"Xf2dP","speaker":"orqrz","phone":"zH+-9"};